// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__ynOkq","campaignBox":"styles_campaignBox__YaWY3","campaignBoxWrapper":"styles_campaignBoxWrapper__Ca95l","campaignDesc":"styles_campaignDesc__ZFoJq","campaignTitle":"styles_campaignTitle__4NvTB"};
module.exports.__checksum = "30b86613f50d"